import React from "react";
import { BrowserRouter as Router, Routes, Route, useRoutes } from "react-router-dom";
import Home from './pages/home.js';
import Dashboard from "./pages/dashboard.js";
import Joinnow from "./pages/joinnow.js";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { WagmiConfig, createConfig, configureChains, mainnet } from 'wagmi'
import { publicProvider } from 'wagmi/providers/public'
import { InjectedConnector } from 'wagmi/connectors/injected'
import { MetaMaskConnector } from 'wagmi/connectors/metaMask'
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect'
import { bsc, bscTestnet, polygon, polygonMumbai } from "wagmi/chains";
import { infuraProvider } from "wagmi/providers/infura";
import { Provider } from "react-redux";
import store from './store'
import config from "./config/config";
import SpinnerPage from "./pages/spinner.js";

const { chains, publicClient, webSocketPublicClient } = configureChains(
  [polygon, polygonMumbai],
  [infuraProvider({
    apiKey: config.projectId,
  }), publicProvider()],
)

const wconfigInitial = createConfig({
  autoConnect: true,
  connectors: [
    new MetaMaskConnector({ chains }),
    new WalletConnectConnector({
      chains,
      options: {
        projectId: config.projectId,
        version: 2
      },
    })
  ],
  publicClient,
  webSocketPublicClient,
});

const App = () => {
  const routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "/join-now", element: <Joinnow /> },
    { path: "/join-now/:id", element: <Joinnow /> },
    { path: "/dashboard", element: <Dashboard /> },
    { path: '/spinner', element: <SpinnerPage /> }
  ]);
  return routes;
};

const AppWrapper = () => {
  return (
    <Provider store={store}>
      <Router basename="/">
        <ToastContainer />
        <WagmiConfig config={wconfigInitial}>
          <App />
        </WagmiConfig>
      </Router>
    </Provider>
  );
};

export default AppWrapper;